import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SmPolicyLinkComponent} from './sm-policy-link.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SmPolicyLinkComponent],
  exports: [SmPolicyLinkComponent],
})
export class SmPolicyLinkModule {}
